import type { ReactNode } from 'react';
import Card from './Card';

interface SettingsSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

const SettingsSection = ({ title, description, children, className = '' }: SettingsSectionProps) => {
  return (
    <Card className={`space-y-4 ${className}`}>
      <div className="border-b border-border pb-3">
        <h2 className="text-lg font-semibold text-text-primary">
          {title}
        </h2>
        {description && (
          <p className="text-sm text-text-muted mt-1">
            {description}
          </p>
        )}
      </div>
      
      <div className="space-y-4">
        {children}
      </div>
    </Card>
  );
};

export default SettingsSection;